/**
 * EventSelector Component
 * Dropdown for selecting quarterly events
 * Feature: User Management (002-user-management)
 */

import React, { useState, useEffect } from 'react';
import ApiService from '../services/ApiService';
import './EventSelector.css';

const EventSelector = ({ value, onChange, filter = 'all', disabled = false }) => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadEvents();
  }, [filter]);

  const loadEvents = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await ApiService.get('/sessions/events');
      console.log('EventSelector API response:', response);
      let filteredEvents = response.data || [];
      console.log('Filtered events:', filteredEvents);

      // Apply filter
      if (filter === 'active') {
        filteredEvents = filteredEvents.filter(e => e.status === 'active');
      } else if (filter === 'archived') {
        filteredEvents = filteredEvents.filter(e => e.status === 'archived');
      }

      console.log('Events after filter:', filteredEvents);
      setEvents(filteredEvents);
    } catch (err) {
      setError('Failed to load events');
      console.error('Error loading events:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <select className="event-selector" disabled>
        <option>Loading events...</option>
      </select>
    );
  }

  if (error) {
    return (
      <select className="event-selector" disabled>
        <option>{error}</option>
      </select>
    );
  }

  return (
    <select
      className="event-selector"
      value={value || ''}
      onChange={(e) => {
        console.log('EventSelector onChange - raw value:', e.target.value);
        console.log('EventSelector onChange - type:', typeof e.target.value);
        const selectedValue = e.target.value === '' ? null : e.target.value;
        onChange(selectedValue);
      }}
      disabled={disabled}
    >
      <option value="">Select Event</option>
      {events.map((event) => {
        console.log('EventSelector render - event:', event);
        return (
          <option key={event.id} value={event.id}>
            {event.eventName} - {new Date(event.eventDate).toLocaleDateString()}
          </option>
        );
      })}
    </select>
  );
};

export default EventSelector;
